import { ReactNode } from "react";
import {
  View,
  Text,
  TouchableOpacity
} from "react-native";
import dayjs from "dayjs";
import { useGetCurrentUserQuery } from "@/_store/currentUser/currentUser.slice";
import { useGetFullMonitoringInfoQuery } from "@/_store/monitoringSubscription/monitoring.slice";
import { DATE_FORMAT } from "@/_utils/formatDate";
import NotificationIcon from "@/assets/icons/main/redIcon.svg";
import CustomButton from "@/app/components/CustomButton";
import RiskIndicator from "@/app/components/RiskIndicator/RiskIndicator";
import css from "./SubscriptionMonitoring.module.css";
import useCustomBottomSheet from "@/_hooks/useBottomSheet";
import { OPEN_GETTING_MONITORING_SECTION } from "@/_utils/contstans";
import { IRevision } from "@/_store/monitoringSubscription/contracts";
import { Router, useRouter } from "expo-router";

const SubscriptionMonitoring = () => {
  const { data: currentUser } = useGetCurrentUserQuery();
  const { openSheet } = useCustomBottomSheet();
  const router: Router = useRouter();

  const subscriptionId: string | undefined = currentUser?.subscription?.id;
  const hasSubscribedToChecks: boolean | undefined = currentUser?.subscription?.subscribed_to_checks;

  const { data: fullMonitoringData } = useGetFullMonitoringInfoQuery({ id: subscriptionId! }, {skip: !subscriptionId });

  const nextRevision: IRevision | undefined = fullMonitoringData?.upcoming_revisions?.find(
    (revision) => revision.next_check);


  const companyName: string = fullMonitoringData?.name || '';
  const monitoringTitle: string = hasSubscribedToChecks
    ? `Отслеживание проверок ${companyName}`
    : 'Уведомления о проверках компании надзорными органами';

  const monitoringContent: ReactNode = hasSubscribedToChecks ? (
    nextRevision ? (
      <View>
        <View className="flex-row gap-4">
          <NotificationIcon />
          <View className="flex-1 gap-0.5">
            <Text className="text-sm text-gray">
              Следующая проверка · {dayjs(nextRevision?.startDate).format(DATE_FORMAT)}
            </Text>
            <Text className="text-base text-black">{nextRevision?.organ}</Text>
          </View>
        </View>
      </View>
    ) : (
      <View style={{ marginTop: 8 }}>
        <RiskIndicator
          level="green"
          text="В ближайшее время проверки не запланированы."
        />
      </View>
    )
  ) : (
    <Text className="text-base text-gray mb-5">
      Получайте уведомления о предстоящих проверках вашей компании на электронную
      почту и на главной странице.
    </Text>
  );

  const handleOpenSheet = (sheet: number) => (): void => {

    if (hasSubscribedToChecks){

      return router.push("/(main)/subscriptionAnalytics");
    }
    openSheet(sheet);
  };

  return (
    <TouchableOpacity className={css.container} onPress={handleOpenSheet(OPEN_GETTING_MONITORING_SECTION)}>
      <View className="flex-col">
        <Text className="text-md mb-3 text-black">
          {monitoringTitle}
        </Text>
        {monitoringContent}
        {!hasSubscribedToChecks && <CustomButton title="Подробнее" onPress={handleOpenSheet(OPEN_GETTING_MONITORING_SECTION)} />}
      </View>
    </TouchableOpacity>
  );
};

export default SubscriptionMonitoring;
